/*
File: api/bridges_tonnels.js
Description: API connections for the async functions for Bridges & Tonnels.
*/
import Api_ref, { getLang } from '@/api'
import basemaps from '@/store/jsons/basemaps.json'

const { Api, type_json } = Api_ref.props;

const getHeaders = () => ({
  headers: {
    ...type_json
  }
});

export default {
  /*  ---------  Bridges&Tonnels  ---------------------*/
  /** Table data
   * @return {Promise<*> {}} - 200 Response
   * @throws Error
   */
  load_bridges_table() {
    return Api.get(`/bridges/table`, getHeaders());
  },

  /** Bridges coords
   * @return {Promise<*> {}} - 200 Response
   * @throws Error
   */
  load_bridges_coords() {
    return Api.get(`/bridges/coords`, getHeaders());
  },

  /** Bridge details
   * @param {string} uuid
   * @return {Promise<*> {}} - 200 Response
   * @throws Error
   */
  load_bridge_details(uuid) {
    return Api.get(`/bridges/${uuid}`, getHeaders());
  },

  /** Add new bridge
   * @param {object} payload
   */
  add_bridge(payload) {
    return Api.post(`/bridges`, payload, getHeaders());
  },

  /** Update existing bridge
   * @param {string} uuid
   * @param {object} payload
   */
  update_bridge(uuid, payload) {
    return Api.put(`/bridges/${uuid}`, payload, getHeaders());
  },

  /** Delete bridge
   * @param {string} uuid
   */
  delete_bridge(uuid) {
    return Api.delete(`/bridges/${uuid}`, getHeaders());
  },

  /** Structural soundness list for dropdown
   * @return {Promise<*>}
   */
  structural_soundness_list() {
    // include current language as query param so backend returns localized names
    const lang = getLang();
    return Api.get('/bridges/structural_soundness', { params: { lang }, ...getHeaders() });
  },

  /** Materials list for dropdown
   * @return {Promise<*>}
   */
  material_list() {
    const lang = getLang();
    return Api.get('/bridges/material', { params: { lang }, ...getHeaders() });
  },

  /** Structural type 1 list for dropdown
   * @return {Promise<*>}
   */
  structural_type_1_list() {
    const lang = getLang();
    return Api.get('/bridges/structural_type_1', { params: { lang }, ...getHeaders() });
  },

  /** Structural type 2 list for dropdown
   * @return {Promise<*>}
   */
  structural_type_2_list() {
    const lang = getLang();
    return Api.get('/bridges/structural_type_2', { params: { lang }, ...getHeaders() });
  },

  /** Structural type of pier list for dropdown
   * @return {Promise<*>}
   */
  structural_type_pier_list() {
    const lang = getLang();
    return Api.get('/bridges/structural_type_pier', { params: { lang }, ...getHeaders() });
  },

  /** tunnels all (renamed from coords)
   * @return {Promise<*> {}} - 200 Response
   * @throws Error
   */
  load_tunnels_all() {
    return Api.get(`/tunnels/all`, getHeaders());
  },

  /** Tunnel details
   * @param {string} uuid
   * @return {Promise<*> {}} - 200 Response
   * @throws Error
   */
  load_tunnel_details(uuid) {
    return Api.get(`/tunnels/${uuid}`, getHeaders());
  },

  /** Add new tunnel
   * @param {object} payload
   */
  add_tunnel(payload) {
    return Api.post(`/tunnels/`, payload, getHeaders());
  },

  /** Update existing tunnel
   * @param {string} uuid
   * @param {object} payload
   */
  update_tunnel(uuid, payload) {
    return Api.put(`/tunnels/${uuid}`, payload, getHeaders());
  },

  /** Delete tunnel
   * @param {string} uuid
   */
  delete_tunnel(uuid) {
    return Api.delete(`/tunnels/${uuid}`, getHeaders());
  },

  load_basemaps() {
    return { status: 200, data: basemaps }
  }
}